"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qrCodeSettingsTabs = void 0;
exports.qrCodeSettingsTabs = {
    registration: {
        text: "User registration",
        value: "user registration",
    },
    modules: {
        text: "Join modules",
        value: "join modules",
    },
    traqs: {
        text: "Join traqs",
        value: "join traqs",
    },
    steps: {
        text: "Do steps",
        value: "do steps",
    },
};
